module.exports = __webpack_public_path__ + "static/media/marketing-freelancer-hero-image.795bdd33.webp";